export default () => {
    return {
        devices: [],
        device: null,
        isEditable: false,
    }
}
